import * as yup from 'yup';

// Yup schema for group add request validation
const groupAddValidationSchema = yup.object({
  groupid: yup
    .number()
    .positive('Group ID must be a positive number')
    .integer('Group ID must be an integer')
    .required('Group ID is required'),
  type: yup
    .string()
    .oneOf(['gallery', 'collection'], 'Type must be either "gallery" or "collection"')
    .required('Type is required'),
  folderid: yup
    .number()
    .positive('Folder ID must be a positive number')
    .integer('Folder ID must be an integer')
    .required('Folder ID is required'),
  deviationid: yup
    .number()
    .positive('Deviation ID must be a positive number')
    .integer('Deviation ID must be an integer')
    .required('Deviation ID is required'),
});

/**
 * Validates group add request data using Yup schema
 * Based on papiRequestDaDeviationGroupAddSchema
 * @param data The request data to validate
 * @returns boolean indicating if validation passed
 */
export function validateGroupAddRequest(data: any): boolean {
  try {
    groupAddValidationSchema.validateSync(data, { abortEarly: false });
    return true;
  } catch (error) {
    return false;
  }
}
